import React, { useState, useEffect } from "react";
import Dropdown from "../../../components/Form/Dropdown";
import Label from "../../../components/Form/Label";
import TextInput from "../../../components/Form/TextInput";
import FileInput from "../../../components/Form/FileInput";
import BtnSaveRecord from "../../../components/Form/Button/BtnSaveRecord";
import { TrashIcon, PencilIcon, CheckIcon } from "@heroicons/react/outline";

import configuration from "../../../config";
import { toast } from "react-toastify";
import { each } from "underscore";
import Loader from "../../../components/Loader/Loader";
import { func } from "prop-types";

let Id = "";
// List Settings
function Summary() {
  const [editFlag, setEditFlag] = useState(false);
  const [vehicleType, setVehicleType] = useState([]);
  const [fields, setFields] = useState({});
  const [vehicleList, setVehicleList] = useState([]);
  const [listDocs, setListDocs] = useState([]);
  const [isLoader, setIsLoader] = useState(false);
  const [fieldArr2, setFieldArr2] = useState([
    { id: 0, title: "Plate number", name: "plate_no", type: "TextInput" },
  ]);
  const [docs, setDocs] = useState([]);
  const [errors, setErrors] = useState({});
  function getVehicle(Id) {
    configuration
      .getAPI({ url: "driver/get-vehicle-list", params: { user_id: Id } })
      .then((data) => {
        if (data.status === 200) {
          setVehicleList(data.payload);
        }
      })
      .catch((error) => {
        return toast.error(error.message);
      });
  }
  useEffect(() => {
    setIsLoader(true);
    var url = window.location.href;
    Id = url.substring(url.lastIndexOf("/") + 1);
    // configuration
    //   .getAPI({ url: "vehicle/list", params: { status: "active" } })
    //   .then((data1) => {
    //     setIsLoader(false);
    //     if (data1.status === 200) {
    //       setVehicleType(data1.payload);
    //       let listData = [];
    //       each(data1.payload, (element) => {
    //         listData.push({
    //           title: `${element.vehicle_make} -- ${element.vehicle_model} -- ${element.year}`,
    //           value: element.vehicle_id,
    //           id: element.vehicle_id,
    //         });
    //       });
    //       let fieldArr_data = [];
    //       const orderNoObj = {
    //         id: 1,
    //         title: "Vehicle Type",
    //         name: "vehicle_id",
    //         type: "Dropdown",
    //         options: listData,
    //       };
    //       fieldArr_data.push(orderNoObj);
    //       configuration
    //         .getAPI({
    //           url: "driver/get-vehicle-document",
    //           params: { user_id: Id },
    //         })
    //         .then((data) => {
    //           if (data.status === 200) {
    //             // setVehicleList(data.payload)
    //             let documents = data.payload;
    //             setListDocs(data.payload);
    //             documents.map((doc, index) => {
    //               fieldArr_data.push({
    //                 id: 3 + index,
    //                 title: doc.title,
    //                 name: doc.vehicle_document_id,
    //                 type: "FileInput",
    //               });
    //             });
    //             setFieldArr2([...fieldArr2, ...fieldArr_data]);
    //           }
    //         })
    //         .catch((error) => {
    //           return toast.error(error.message);
    //         });
    //     }
    //   })
    //   .catch((error) => {
    //     setIsLoader(false);
    //     return toast.error(error.message);
    //   });
    configuration
      .getAPI({ url: "ride-option/list", params: { status: "active" } })
      .then((data1) => {
        setIsLoader(false);
        if (data1.status === 200) {
          setVehicleType(data1.payload);
          let listData = [];
          each(data1.payload, (element) => {
            listData.push({
              title: `${element.caption.EN}`,
              value: element.vehicle_ride_option_id,
              id: element.vehicle_ride_option_id,
            });
          });
          let fieldArr_data = [];
          const orderNoObj = {
            id: 1,
            title: "Ride Option",
            name: "vehicle_ride_option_id",
            type: "Dropdown",
            options: listData,
          };
          const MakeObj = {
            id: 1,
            title: "Make",
            name: "make",
            type: "TextInput",
            options: listData,
          };
          const ModelObj = {
            id: 1,
            title: "Model",
            name: "model",
            type: "TextInput",
            options: listData,
          };
          const YearObj = {
            id: 1,
            title: "Year",
            name: "year",
            type: "TextInput",
            options: listData,
          };
          const ColorObj = {
            id: 1,
            title: "Color",
            name: "color",
            type: "TextInput",
            options: listData,
          };
          fieldArr_data.push(orderNoObj);
          fieldArr_data.push(MakeObj);
          fieldArr_data.push(ModelObj);
          fieldArr_data.push(YearObj);
          fieldArr_data.push(ColorObj);
          configuration
            .getAPI({
              url: "driver/get-vehicle-document",
              params: { user_id: Id },
            })
            .then((data) => {
              if (data.status === 200) {
                // setVehicleList(data.payload)
                let documents = data.payload;
                setListDocs(data.payload);
                documents.map((doc, index) => {
                  fieldArr_data.push({
                    id: 3 + index,
                    title: doc.title,
                    name: doc.vehicle_document_id,
                    type: "FileInput",
                  });
                });
                setFieldArr2([...fieldArr2, ...fieldArr_data]);
              }
            })
            .catch((error) => {
              return toast.error(error.message);
            });
        }
      })
      .catch((error) => {
        setIsLoader(false);
        return toast.error(error.message);
      });
    getVehicle(Id);
    // console.log(configuration.baseURL);
  }, []);
  function handleChange(field, e) {
    if (
      field === "vehicle_ride_option_id" ||
      field === "plate_no" ||
      field === "vehicle_mobility_ids" ||
      field === "make" ||
      field === "model" ||
      field === "year" ||
      field === "color"
    ) {
      setFields({ ...fields, [field]: e.target.value });
    } else {
      setFields({ ...fields, [field]: URL.createObjectURL(e.target.files[0]) });
      setDocs({ ...docs, [field]: e.target.files[0] });
    }
  }
  function cancleImage(field, e) {
    setFields({ ...fields, [field]: "" });
    setDocs({ ...docs, [field]: null });
  }

  function handleValidation() {
    let flag = true;
    let error = {};

    if (!fields.vehicle_ride_option_id) {
      error["vehicle_ride_option_id"] = "Please select ride option";
      flag = false;
    }

    if (!fields.make) {
      error["make"] = "Please enter make";
      flag = false;
    }
    if (!fields.model) {
      error["model"] = "Please enter model";
      flag = false;
    }
    if (!fields.year) {
      error["year"] = "Please enter year";
      flag = false;
    }
    if (!fields.color) {
      error["color"] = "Please enter color";
      flag = false;
    }

    if (!fields.plate_no) {
      error["plate_no"] = "Please enter plate number";
      flag = false;
    }
    listDocs.map((sinDoc) => {
      // console.log(fields[sinDoc.vehicle_document_id])
      if (
        !fields[sinDoc.vehicle_document_id] ||
        fields[sinDoc.vehicle_document_id] === ""
      ) {
        error[sinDoc.vehicle_document_id] = `Please select ${sinDoc.title}`;
        flag = false;
      }
    });
    setErrors({ ...error });
    return flag;
  }

  const handleSubmit = () => {
    if (handleValidation()) {
      setIsLoader(true);
      const formData = new FormData();
      listDocs.map((sinDoc) => {
        if (docs[sinDoc.vehicle_document_id]) {
          formData.append(
            sinDoc.vehicle_document_id,
            docs[sinDoc.vehicle_document_id],
          );
        }
      });
      formData.append(
        "fields",
        JSON.stringify({ ...fields, lang_code: "EN", user_id: Id }),
      );
      const apiURL = editFlag ? "driver/update-vehicle" : "driver/add-vehicle";

      configuration
        .postFormDataAPI({ url: apiURL, params: formData })
        .then((data) => {
          setIsLoader(false);
          if (data.status === 200) {
            // setPhoto(null);
            setFields({
              vehicle_ride_option_id: "",
              plate_no: "",
              make: "",
              model: "",
              year: "",
              color: "",
            });
            setDocs([]);
            setEditFlag(false);
            getVehicle(Id);
            return toast.success(
              editFlag
                ? "Vehicle updated successfully"
                : "Vehicle added successfully",
            );
          } else if (data.status === 404) {
            setIsLoader(false);
            return toast.error(data.error.message);
          } else {
            setIsLoader(false);
            return toast.error("Something went wrong");
          }
        })
        .catch((error) => {
          setIsLoader(false);
          return toast.error(error.message);
        });
    }
  };
  function handleDelete(driver_vehicle_id) {
    setIsLoader(true);
    configuration
      .postAPI({
        url: "driver/remove-vehicle",
        params: { user_id: Id, driver_vehicle_id: driver_vehicle_id },
      })
      .then((data) => {
        setIsLoader(false);
        if (data.status === 200) {
          getVehicle(Id);
          return toast.error("Vehicle deleted successfully");
        } else if (data.error) {
          setIsLoader(false);
          return toast.error(data.error.message);
        } else {
          setIsLoader(false);
          return toast.error("Something went wrong");
        }
      })
      .catch((error) => {
        setIsLoader(false);
        return toast.error(error.message);
      });
  }
  function handleEdit(driver_vehicle_id) {
    configuration
      .getAPI({
        url: "driver/get-vehicle-list",
        params: { user_id: Id, driver_vehicle_id: driver_vehicle_id },
      })
      .then((data) => {
        if (data.status === 200) {
          let fieldData = {};
          each(data.payload.vehicle_documents, (single) => {
            fieldData[single.vehicle_document_id] = single.photo;
          });
          setFields({ ...data.payload, ...fieldData });
          setErrors({});
          setEditFlag(true);
        }
      })
      .catch((error) => {
        return toast.error(error.message);
      });
  }
  function handleClear() {
    setEditFlag(false);
    setFields({
      vehicle_id: "",
      plate_no: "",
    });
    setDocs([]);
    setErrors({});
    getVehicle(Id);
  }

  function handleApprove(driver_vehicle_id) {
    setIsLoader(true);
    configuration
      .postAPI({
        url: "driver/approve-vehicle",
        params: { user_id: Id, driver_vehicle_id: driver_vehicle_id },
      })
      .then((data) => {
        setIsLoader(false);
        if (data.status === 200) {
          getVehicle(Id);
          return toast.success("Vehicle approved successfully");
        } else if (data.error) {
          setIsLoader(false);
          return toast.error(data.error.message);
        } else {
          setIsLoader(false);
          return toast.error("Something went wrong");
        }
      })
      .catch((error) => {
        setIsLoader(false);
        return toast.error(error.message);
      });
  }

  return (
    <>
      {isLoader ? <Loader /> : ""}
      <div className="md:pl-8 sm:py-7 col-span-10">
        <section aria-labelledby="applicant-information-title">
          <div className="bg-white shadow sm:rounded-lg">
            <div className="px-4 py-5 sm:px-6">
              <h2
                id="applicant-information-title"
                className="text-lg leading-6 font-medium text-gray-900"
              >
                Vehicle Info
              </h2>
              <p className="mt-1 max-w-2xl text-base text-gray-500 text_theme">
                This information is show driver vehicles details.
              </p>
            </div>
            <div className="border-t border-gray-200 px-4 py-5 sm:px-6">
              <h2
                id="applicant-information-title"
                className="mb-3 text-lg leading-6 font-medium text-gray-900"
              >
                Add Vehicle
              </h2>
              <div className="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                {fieldArr2.map((field) => {
                  return (
                    <div className="sm:col-span-3" key={field.id}>
                      <Label title={field.title} />
                      <div className="mt-1">
                        {field.type === "TextInput" ? (
                          <TextInput
                            id={field.name}
                            name={field.name}
                            value={fields[field.name]}
                            handleChange={handleChange}
                            is_number={field.is_number || false}
                            is_password={field.is_password || false}
                          />
                        ) : field.type === "Dropdown" ? (
                          <Dropdown
                            id={field.name}
                            value={fields[field.name]}
                            name={field.name}
                            handleChange={handleChange}
                            status={field.options || []}
                          />
                        ) : field.type === "FileInput" ? (
                          <FileInput
                            id={field.name}
                            value={fields[field.name]}
                            handleChange={handleChange}
                            cancleImage={cancleImage}
                            name={field.name}
                          />
                        ) : null}
                      </div>
                      {errors[field.name] ? (
                        <Label
                          title={field.title}
                          fieldError={errors[field.name]}
                        />
                      ) : null}
                    </div>
                  );
                })}
              </div>
              <div className="pt-5 border_color_theme">
                <div className="flex justify-end">
                  <button
                    type="button"
                    className="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 xl-admin-btn"
                    onClick={() => handleClear()}
                  >
                    Clear
                  </button>
                  <BtnSaveRecord
                    title={editFlag ? "Update" : "Save"}
                    handleSubmit={handleSubmit}
                    path="/driverprofile"
                  />
                </div>
              </div>

              <h2 className="mb-6 text-xl font-bold text-gray-800 tracking-tight border-b pb-3">
                Vehicles
              </h2>

              <ul role="list" className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                {vehicleList.map((product) => (
                  <li
                    key={product.driver_vehicle_id}
                    className="flex flex-col justify-between bg-white border border-gray-200 rounded-xl shadow-sm hover:shadow-md transition-shadow duration-200 overflow-hidden"
                  >
                    {/* Status Bar */}
                    <div
                      className={`w-full h-1.5 ${
                        product.is_approved ? "bg-green-400" : "bg-yellow-400"
                      }`}
                    />

                    <div className="p-5">
                      {/* Header Row: Plate + Status Badge */}
                      <div className="flex items-center justify-between mb-3">
                        <h3 className="text-base font-bold text-gray-800 tracking-wide uppercase">
                          {product.plate_no}
                        </h3>
                        <span
                          className={`text-xs font-semibold px-2.5 py-0.5 rounded-full ${
                            product.is_approved
                              ? "bg-green-100 text-green-700"
                              : "bg-yellow-100 text-yellow-700"
                          }`}
                        >
                          {product.is_approved ? "✓ Approved" : "⏳ Pending"}
                        </span>
                      </div>

                      {/* Vehicle Info */}
                      <p className="text-sm font-semibold text-gray-700">
                        {product.make}
                      </p>
                      <p className="text-sm text-gray-500 mt-0.5">
                        {product.model} · {product.year}
                        {product.ride_option && (
                          <span className="ml-1 text-xs bg-gray-100 text-gray-600 px-2 py-0.5 rounded-full">
                            {product.ride_option}
                          </span>
                        )}
                      </p>
                    </div>

                    {/* Action Footer */}
                    <div className="flex items-center justify-end gap-2 px-5 py-3 bg-gray-50 border-t border-gray-100">
                      {/* Approve */}
                      {!product?.is_approved &&
                        product?.vehicle_ride_option_id && (
                          <button
                            title="Approve"
                            type="button"
                            onClick={() =>
                              handleApprove(product.driver_vehicle_id)
                            }
                            className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium bg-green-600 hover:bg-green-700 text-white rounded-lg transition-colors duration-150"
                          >
                            <CheckIcon className="h-4 w-4" />
                            Approve
                          </button>
                        )}

                      {/* Edit */}
                      <button
                        type="button"
                        title="Edit"
                        onClick={() => handleEdit(product.driver_vehicle_id)}
                        className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg transition-colors duration-150"
                      >
                        <PencilIcon className="h-4 w-4" />
                        Edit
                      </button>

                      {/* Delete */}
                      <button
                        type="button"
                        title="Remove"
                        onClick={() => handleDelete(product.driver_vehicle_id)}
                        className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium bg-red-600 hover:bg-red-700 text-white rounded-lg transition-colors duration-150"
                      >
                        <TrashIcon className="h-4 w-4" />
                        Remove
                      </button>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default Summary;
